import { z } from "zod";
import { IsoDateTime, OpaqueId, Seq } from "./common.js";
/**
 * Alertes issues des flux GTFS-RT (`Alert`), EN LECTURE SEULE (CDC §2.1).
 * Aucune création par le régulateur — le lot d'action est abandonné.
 */
export const Alert = z.object({
    id: OpaqueId,
    header: z.string(),
    description: z.string(),
    url: z.string().nullable().default(null), // v1.48 — lien « plus d'infos » du flux GTFS-RT (`Alert.url`)
    severity: z.enum(["info", "warning", "severe"]),
    cause: z.string().nullable(),
    effect: z.string().nullable(),
    activePeriod: z.object({
        start: IsoDateTime.nullable(),
        end: IsoDateTime.nullable(),
    }),
    informedLineIds: z.array(OpaqueId),
    informedStopIds: z.array(OpaqueId),
    updatedAt: IsoDateTime,
});
export const AlertsResponse = z.object({ seq: Seq, alerts: z.array(Alert) }); // D-009
//# sourceMappingURL=alert.js.map